// import { BreadCrumb } from '../components/common'
import { useAuthStore } from '../store/authStore'
import { impersonateUser } from '../pages/users/api'
import { useSnackbarManager } from '../components/common/snackbar'

export default function ImpersonateBar() {
  const {
    actualeUser,
    userData,
    impersonating,
    setImpersonating,
    setUserData,
    setToken,
  } = useAuthStore()
  const { enqueueSnackbar } = useSnackbarManager()

  const handleStopImpersonating = () => {
    setImpersonating(false)
    localStorage.setItem('shouldReload', 'false')
    impersonateUser(actualeUser?.id ?? '')
      .then((res) => {
        // setPermissionData(res.data?.role?.permissions)
        setToken(res?.access_token)
        setUserData({
          ...res?.user,
          is_admin: res?.user?.role?.name == 'user' ? false : true,
          name: res?.name,
          is_operations_head: res?.is_operations_head,
        })
        // setFranchisee({
        //   ...res?.data?.franchisee,
        //   is_default_franchisee: true,
        // })
        setImpersonating(false)
        if (res?.user?.role?.name == 'admin') {
          window.open('dashboard', '_self')
        } else {
          window.location.reload()
        }
        localStorage.setItem('shouldReload', 'true')
      })
      .catch((err) => {
        enqueueSnackbar(err.response.data.message, { variant: 'error' })
      })
  }

  return (
    <>
      <header
        className={`${
          impersonating ? 'bg-primary grid-cols-3  ' : 'bg-white grid-cols-2'
        } dark:bg-gray-700 dark:text-white   text-gray-700 grid border-b border-divider py-3 px-4  z-10 h-16`}
      >
        {/* {impersonating && ( */}
        <div className="flex justify-center items-center">
          <p className=" text-white text-sm">
            {`You are impersonating ${userData?.name}   `}
            <span
              className=" underline cursor-pointer"
              onClick={handleStopImpersonating}
            >
              Exit Now
            </span>
          </p>
        </div>
        {/* )} */}
      </header>
    </>
  )
}
